import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface IProps {
    error?: boolean;
    retry?: () => void;
    color?: 'primary' | 'secondary';
    size?: string | number;
}

export const Loading = ({ error, retry, color = 'secondary', size = '1.5em' }: IProps) => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            {error && retry ? (
                <Button className="bg-secondary dark:bg-secondary" onClick={retry} variant="contained">
                    Retry
                </Button>
            ) : (
                <Spinner size={size} className={color === 'primary' ? 'text-primary' : 'text-secondary'} />
            )}
        </div>
    );
};
